import React from "react";
import Todo from "../assets/Todo.png"
import Weather from "../assets/weather.png"
import Calculator from "../assets/kalkulator.png"
import Schedule from "../assets/Java1.png"
import SellApp from "../assets/javaApp.png"
import Memories from "../assets/memoriesApp.png"
import Blog from "../assets/Blog.png"
import Movies from "../assets/movies.PNG"
import Recipes from "../assets/Recipes.png"

const projects = [
    
    {
        id: 5,
        name: "Full stack web app",
        desc: "Application with picture uploading functionality(node, mongoDB), web responsive",
        img: Memories,
        link:"https://boring-mahavira-36664a.netlify.app"
    },
    {
        id: 9,
        name: "Recipes",
        desc: "Fullstack app made with React Node(Nest framework) and postgres db... Link to github(backend and frontend recipe repositories)",
        img: Recipes,
        link: "https://github.com/Ranko1996?tab=repositories"
    },
    {
        id: 8,
        name: "Simple movie app",
        desc: "Showcase of popular movies with animations",
        img: Movies,
        link:"https://magnificent-begonia-48c10a.netlify.app/"
    },
    {
        id: 1,
        name: "Selling app",
        desc: "Java mobile application, based on firebase realtime database",
        img: SellApp,
        link: "https://github.com/Ranko1996/diplomski-rad-sell",
    },
    {
        id: 2,
        name: "Weather App",
        desc: "Mobile responsive app to show weather of certain location",
        img: Weather,
        link:"https://upbeat-lamarr-a5a3be.netlify.app/",
    },
    {
        id: 3,
        name: "Schedule",
        desc: "Java desktop application, made with Intellij IDEA and Xampp",
        img: Schedule,
        link: "https://github.com/Ranko1996/JavaProjekt2021",
    },
    {
        id: 4,
        name: "Calculator",
        desc: "Calculator that does simple calculations",
        img: Calculator,
        link: "https://zealous-borg-db76c2.netlify.app/",
    },
    {
        id: 6,
        name: "Simple ordinary Todo list",
        desc: "An application to track your todos throughout the day",
        img: Todo,
        link:"https://elated-wiles-df34b9.netlify.app/",
    },
     
];

export default projects;